<template>
  <el-select v-bind="$attrs" v-on="$listeners" class="b-select">
    <slot></slot>
  </el-select>
</template>

<script>
export default {
  name: 'AdbSelect',
};
</script>
<style lang="scss" scoped>
.b-select {
  ::v-deep .el-input--small .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}
</style>
